import { ScrollbarTheme } from 'components/horizontal-scroller/horizontal-scroller';

export interface IResponsiveCarouselProps {
  children: React.ReactNode[];
  bgColor?: string;
  scrollbarTheme?: ScrollbarTheme;
  centerCards?: boolean;
}

export interface ISideButtonWrappedProps {
  isMobile: boolean;
  bgColor: string;
  isOverflow: boolean;
}

export enum Sizes {
  SPACER = 8,
}
